import gql from 'graphql-tag';
import { WorkflowFragment } from '../fragments/workflow.fragment';
import { PageFragment } from '../fragments/page.fragment';
import { TransactionFragment } from '../fragments/transaction.fragment';
import { KioskFragment } from '../fragments/kiosk.fragment';
import { GameAccountFragment } from '../fragments/game-account.fragment';

export const GET_WORKFLOWS = gql`
  query(
    $filter: WorkflowFilter
    $paging: CursorPaging
    $sorting: [WorkflowSort!]
  ) {
    workflows(
      paging: $paging
      filter: $filter
      sorting: $sorting
    ) {
      pageInfo {
        ...Page
      }
      edges {
        node {
          ...WorkflowInfo
          quantity
          player {
            id
            serialNo
            name
            username
            phoneNo
          }
          paymentType {
            id
            name
          }
          playerBankAccount {
            id
            accountName
            accountNo
            bank {
              id
              name
            }
          }
          companyBankAccount {
            id
            accountName
            accountNo
            bank {
              id
              name
            }
          }
          bonus {
            id
            name
          }
          paymentGateway {
            id
            name
          }
          toGameAccount {
            ...GameAccountInfo
          }
          fromGameAccount {
            ...GameAccountInfo
          }
          transactions {
            edges {
              node {
                ...TransactionInfo
                supersededById
                stepNumber
                retryAttempts
                player {
                  upline {
                    id
                    username
                  }
                  id
                  serialNo
                  username
                  name
                  phoneNo
                  telegramId
                  lastDepositAmount
                  lastDepositAt
                  tags(sorting: { field: tagType, direction: ASC }) {
                    edges {
                      node {
                        name
                        tagType
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${PageFragment}
  ${WorkflowFragment}
  ${GameAccountFragment}
  ${TransactionFragment}
`;
